// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  stripePublishableKey:
    'pk_test_51NfDVoGvycT5tiWtvuw7zYd1km5PLq6wLXXARll0BSaOWJiRqUA4Isd61ReCZr48Bw59OWswNgLAdS7kTJQmBcu9002SXdHgnT',
  // baseApiUrl: 'http://localhost:3001/api/v1',
  baseApiUrl: '/api/v1',
  firebase: {
    apiKey: 'AIzaSyAzO_KfkeicqbIbYz9yIvKAx4DITlycCnQ',
    authDomain: 'proxdis.firebaseapp.com',
    projectId: 'proxdis',
    storageBucket: 'proxdis.appspot.com',
    messagingSenderId: '404031374791',
    appId: '1:404031374791:web:36aea2364934661b6145e2',
    measurementId: 'G-GRNR4H5K69',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
